import { FilterParams } from 'types/FindAHome/HomeSearchProps';
import { getSessionStorage, setSessionStorage } from '@utils/utils';

const FILTERS_SESSION_KEY = 'home_search_filters';

export function getSessionFilters(): FilterParams {
  return getSessionStorage(FILTERS_SESSION_KEY) ?? {};
}

export function setSessionFilters(sessionFilters: FilterParams): void {
  setSessionStorage(FILTERS_SESSION_KEY, sessionFilters);
}
